:host {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #F9F8F1; /* Marketing colour; no design token */
  border-radius: var(--pdt-radius-100);
  padding: var(--pdt-space-400);
  gap: var(--pdt-space-300);
  user-select: none;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  img {
    width: 100px;
    height: 30px;
  }

  /* New brand colours not yet present in the prism-design-tokens package */
  --pdt-core-color-jade-20: #D9F2E7;
  --pdt-core-color-jade-30: #C7ECDB;
  --pdt-core-color-teal-teal: #063437;
  --pdt-core-color-teal-90: #1F484B;
}

.AppSwitcherAd {
  &__header {
    display: flex;
    flex-direction: column;
    gap: var(--pdt-space-150);
    color: var(--pdt-color-text);

    p[role="heading"] {
      font-size: var(--pdt-text-title-sm-font-size);
      font-weight: var(--pdt-font-weight-semibold);
      line-height: var(--pdt-text-title-sm-line-height);
      margin: 0;
    }

    p {
      font-size: var(--pdt-text-body-sm-font-size);
      font-weight: var(--pdt-font-weight-regular);
      line-height: var(--pdt-text-body-sm-line-height);
      margin: 0;
    }
  }

  &__capabilities {
    display: flex;
    flex-direction: column;
    gap: var(--pdt-space-100);

    &-heading {
      font-size: var(--pdt-text-body-sm-font-size);
      font-weight: var(--pdt-font-weight-medium);
      line-height: var(--pdt-text-body-sm-line-height);
      color: var(--pdt-color-text-bold);
      margin: 0;
    }
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--pdt-space-100);

    &-more {
      font-size: var(--pdt-text-body-xs-font-size);
      line-height: var(--pdt-line-height-2xs);
      color: var(--pdt-color-text);
    }
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    padding: var(--pdt-space-50) var(--pdt-space-150);
    background-color: var(--pdt-core-color-jade-20);
    color: var(--pdt-color-text);
    border: 1px solid transparent;
    border-radius: var(--pdt-radius-full);
    font-size: var(--pdt-text-body-xs-font-size);
    line-height: var(--pdt-line-height-2xs);
    white-space: nowrap;
    text-decoration: none;
    transition: background-color .2s ease;

    &:hover {
      text-decoration: underline;
      background-color: var(--pdt-core-color-jade-30);
    }

    &:focus-visible {
      border-color: var(--pdt-color-border-success);
      box-shadow: var(--pdt-shadow-focus);
      outline: 0;
    }
  }

  &__cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--pdt-space-150);
    margin-top: var(--pdt-space-100);
    padding-block: var(--pdt-space-75);
    padding-inline: var(--pdt-space-250) var(--pdt-space-200);
    background-color: var(--pdt-core-color-teal-teal);
    border-radius: var(--pdt-radius-full);
    text-decoration: none;
    cursor: pointer;
    align-self: flex-start;
    transition: background-color .2s ease;

    span {
      font-size: var(--pdt-text-body-md-font-size);
      font-weight: var(--pdt-font-weight-regular);
      line-height: var(--pdt-text-body-md-line-height);
      color: white;
    }

    pwc-icon-shadow {
      color: white;
    }

    &:hover {
      background-color: #385D5F;
    }

    &:focus-visible {
      box-shadow: var(--pdt-shadow-focus);
      outline: 0;
    }
  }
}
